"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.TaskHeader = void 0;
const React = __importStar(require("react"));
const Heading_1 = require("../../components/heading/Heading");
const Icon_1 = require("../../components/icon/Icon");
const Button_1 = require("../../components/button/Button");
const theme_1 = __importDefault(require("../styles/theme"));
const styled_1 = __importDefault(require("@emotion/styled"));
const LastSavedIndicator_1 = require("../last-saved/LastSavedIndicator");
const viewstate_1 = require("../../../entities/viewstate");
const RoutingContext_1 = require("../../../context/RoutingContext");
const StyledTaskHeader = styled_1.default.div `
	display: flex;
	flex-direction: column;
	@media only screen and (min-width: 768px) {
		flex-direction: row;
		justify-content: space-between;
	}
`;
const BackButtonAndTitle = styled_1.default.div `
	display: flex;
	font-family: ${theme_1.default.typography.fonts.base};

	.merlin-button {
		margin-right: ${theme_1.default.layout.spacing.small};
		height: 40px;
		width: 40px;
	}
	.header-subtitle {
		${theme_1.default.typography.d2};
	}

	.task-header__link-icon {
		display: block;
		width: 20px;
		height: 20px;
		margin 0 -10px;
}
`;
const SaveStatus = styled_1.default.span `
	${theme_1.default.typography.d2};
	// 50px seems to be the calculated width of the button
	margin-left: calc(40px + ${theme_1.default.layout.spacing.small});
	@media only screen and (min-width: 768px) {
		margin: 0;
	}
`;
;
const errorInfo = (message) => React.createElement("div", { style: { color: theme_1.default.colours.error.primary } }, message);
const TaskHeader = (props) => {
    const { taskName, propertyName, lastSaved, errorMessage, viewState } = props;
    let statusElem = React.createElement(React.Fragment, null);
    if (errorMessage !== undefined) {
        statusElem = errorInfo(errorMessage);
    }
    else if (viewState === viewstate_1.ViewState.SAVING) {
        statusElem = React.createElement(React.Fragment, null, "Saving ...");
    }
    else if (lastSaved !== undefined && lastSaved !== null) {
        statusElem = React.createElement(LastSavedIndicator_1.LastSavedIndicator, { lastSaved: lastSaved });
    }
    else {
        statusElem = React.createElement(React.Fragment, null, "No changes since last save");
    }
    return React.createElement(exports.Header, { title: taskName, subtitle: propertyName, saveStatus: statusElem, 
        // Relative path to the base dashboard page
        backLinkTo: '..' });
};
exports.TaskHeader = TaskHeader;
const BackButton = ({ link }) => {
    if (typeof link === 'string') {
        return React.createElement(Button_1.LinkButton, { to: link },
            React.createElement("span", { className: "task-header__link-icon" },
                React.createElement(Icon_1.Icon, { colour: "black", icon: "left" })));
    }
    else {
        return React.createElement(Button_1.Button, { onClick: link },
            React.createElement("span", { className: "task-header__link-icon" },
                React.createElement(Icon_1.Icon, { colour: "black", icon: "left" })));
    }
};
const Header = (props) => {
    const { title, subtitle, saveStatus, noBackLink, backLinkTo, backLinkClick } = props;
    const { baseUrl } = React.useContext(RoutingContext_1.RouterContext);
    return (React.createElement(StyledTaskHeader, null,
        React.createElement(BackButtonAndTitle, null,
            !noBackLink && React.createElement(BackButton, { link: backLinkClick || backLinkTo || baseUrl }),
            React.createElement("div", null,
                React.createElement("span", { className: "header-subtitle" }, subtitle),
                React.createElement("span", null,
                    React.createElement(Heading_1.Heading, null, title)))),
        saveStatus && React.createElement(SaveStatus, { className: "header-save-status" }, saveStatus)));
};
exports.Header = Header;
//# sourceMappingURL=TaskHeader.js.map